import { render } from "./TicketsActionMenuItem.vue?vue&type=template&id=3e074a40"
import script from "./TicketsActionMenuItem.vue?vue&type=script&lang=js"
export * from "./TicketsActionMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__